import(/* webpackMode: "eager" */ "/vercel/path0/apps/app/app/settings/page.tsx");
